<template>
  <div class="delivery-bill d-flex flex-center" v-if="load">
    <div class="print-2023" v-if="listScore.data_info">
      <div class="name-wrap d-flex justify-content-between">
        <div class="name-school d-flex flex-column align-items-center">
          <span>{{ listScore.data_info.school_description }}</span>
          <span>{{ listScore.data_info.school_text }}</span>
          <div class="line-09991"></div>
        </div>
        <div class="name-vn">
          <div class="name_vn_son">
            <span class="text-1">Cộng hòa xã hội chủ nghĩa Việt Nam</span>
            <span class="text-2">Độc lập - Tự do - Hạnh phúc</span>
            <span class="line-0999"></span>
          </div>
        </div>
      </div>
      <div class="main-title-999">
        <div class="d-block mx-auto title1">{{ modelScore.type_time_text }}</div>
        <div class="d-block mx-auto title2" style="font-size: 18px; margin-bottom: 10px;">{{ modelScore.course_name }}</div>
      </div>

      <div class="main-info">
        <el-row :gutter="20">
          <el-col :span="12">
            <div>
              <div class="item-90">
                <span class="title">Họ và tên học viên</span>
                <span class="data">: {{ listScore.data_info.user_name }}</span>
              </div>
              <div class="item-90">
                <span class="title">Giới tính</span>
                <span class="data">: {{ listScore.data_info.sex }}</span>
              </div>
              <div class="item-90">
                <span class="title">Ngày sinh</span>
                <span class="data">: {{ listScore.data_info.user_birtday }}</span>
              </div>
              <div class="item-90">
                <span class="title">Nơi sinh</span>
                <span class="data">: {{ listScore.data_info.user_address }}</span>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div>
              <div class="item-90">
                <span class="title">Khóa học</span>
                <span class="data">: {{ listScore.data_info.class_pro_year }}</span>
              </div>
              <div class="item-90">
                <span class="title">Trình độ đào tạo</span>
                <span class="data">: {{ schoolLevel(listScore.data_info.level_text, listScore.data_info.school_text) }}</span>
              </div>
              <div class="item-90">
                <span class="title">Hệ đào tạo</span>
                <span class="data">: {{ trainingSystem(listScore.data_info.level_text) }}</span>
              </div>
              <div class="item-90">
                <span class="title">Ngành</span>
                <span class="data">: {{ listScore.data_info.facult_text }}</span>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>

      <div>
        <el-row :gutter="20">
          <el-col :span="24">
            <div class="test-list-result mt-3 mb-3">
              <h2>Kết quả thi</h2>
              <div class="item-question" v-for="(question, indexQuestion) in modelScore.list_results" :key="indexQuestion">
                <div>
                  <strong>Câu {{ indexQuestion + 1 }} : </strong>
                  <strong v-html="question.text"></strong>
                </div>
                <div class="list-options test-options" v-if="modelScore.type_question == 1">
                  <!-- <el-checkbox-group v-model="question.model_option">
                    <el-checkbox :label="option.id" v-for="(option,index) in question.options.data" :key="option.id">
                        <span>{{ returnTitle(index) }}</span>
                        {{ option.text }}
                    </el-checkbox>
                  </el-checkbox-group> -->

                  <span class="el-checkbox__label" v-for="(option,index) in question.options.data" :key="option.id">
                    <span data-v-298a6b41="">{{ returnTitle(index) }}</span> {{ option.text }}
                  </span>
                  <br>
                  <span class="el-checkbox__label mb-2">
                    <span data-v-298a6b41="">Câu trả lời của học viên: </span> {{ answer(question) }}
                  </span>

                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <!-- cao đẳng -->
      <template>
        <div class="mt-3">
          <el-row :gutter="20">
            <el-col :span="9">
              <h3 class="mt-0">Tổng kết</h3>
              <table class="no-border" cellspacing="0" cellpadding="0">
                <tr>
                  <td class="huhu text-nowrap-mod">- Tổng số câu hỏi</td>
                  <td>:</td>
                  <td width="50">{{ modelScore.total_question }}</td>
                </tr>
                <tr>
                  <td class="huhu text-nowrap-mod">- Tổng số câu trả lời</td>
                  <td>:</td>
                  <td width="50">{{  modelScore.total_answer }}</td>
                </tr>
                <tr>
                  <td class="huhu text-nowrap-mod" style="white-space: nowrap;">- Tổng số câu trả lời đúng</td>
                  <td>:</td>
                  <td width="50">{{  modelScore.total_success }}</td>
                </tr>
                <tr>
                  <td class="huhu text-nowrap-mod">- Điểm số</td>
                  <td>:</td>
                  <td width="50">{{  modelScore.score }}</td>
                </tr>
                <tr>
                  <td class="huhu text-nowrap-mod">- Xếp loại</td>
                  <td>:</td>
                  <td style="white-space: nowrap;">{{  modelScore.score_status_txt }}</td>
                </tr>
              </table>
            </el-col>
            <el-col :span="7">
              <div class="sign-19231">
                <div class="d-flex flex-column align-items-center">
                  <span class="addresss">{{ listScore.data_info.school_address }}, ngày ...
                    tháng ... năm ...</span>
                  <span class="name">Chữ ký học viên </span>
                  <span class="name" style="text-transform: inherit; font-weight: normal; font-style: italic;">(Ký và ghi rõ họ tên)</span>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="sign-19231">
                <div class="d-flex flex-column align-items-center">
                  <span class="addresss">{{ listScore.data_info.school_address }}, ngày ...
                    tháng ... năm ...</span>
                  <span class="name">Xác nhận của phòng đào tạo</span>
                  <span class="name">KT.Trưởng phòng</span>
                  <span class="name">phó Trưởng phòng</span>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </template>
      <!-- cao đẳng -->
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { mapActions } from 'vuex'
import _, {head} from 'lodash'
export default {
  name: 'ShowPrint',
  metaInfo () {
    return {
      title: 'Lớp học'
    }
  },
  data () {
    return {
      load: false,
      loading: false,
      canSubmit: true,
      modelData: {},
      listScore: [],
      table: [],
      // Xem
      dialogVisible: false,
      modelScore: {},

      // Lop:
      modelDataClassPro: {}
    }
  },
  mounted () {
    // this.fetchModelClassPro()
    // this.fetchModel()
    this.fetchDatabaseModel()
    this.fetchDatabaseModelTestResult()
    setTimeout(() => {
      this.inBill()
    }, 1500)
  },
  computed: {
    getNumberOfObject () {
      return Math.ceil((this.modelScore.list_results.length) / 2)
    }
  },
  methods: {
    returnTitle (index) {
      if (index === 0) return 'A.'
      if (index === 1) return 'B.'
      if (index === 2) return 'C.'
      if (index === 3) return 'D.'
    },
    inBill () {
      window.print()
    },
    // Lấy action từ Vuex
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'class-pros-index', text: 'Lớp học' },
        { name: 'class-pros-show-list-user', id: this.$route.params.id, text: 'Lớp: ' + this.modelDataClassPro.code },
        { name: 'class-pros-update1', text: 'Xem kết quả thi' }
      ]
      this.setBreadcrumb(breadcrumb)
    },
    // Nút back lại trang Index
    backModel () {
      this.$router.push({ name: 'class-pros-show', params: { id: this.$route.params.id } })
    },
    // Tải dữ liệu Model xuống
    fetchModelClassPro () {
      this.canSubmit = false
      axios.get('class-pros/' + this.$route.params.id).then(response => {
        switch (response.code) {
          case 200:
            this.canSubmit = true
            this.modelDataClassPro = response.data
            this.configBreadcrumb()
            setTimeout(() => {
              this.inBill()
            }, 1500)
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    fetchDatabaseModel () {
      this.loading = true
      axios.post('class-users/view-print-v2/' + this.$route.params.id_class_user).then(response => {
        this.loading = false
        switch (response.code) {
          case 200:
            this.listScore = response.data
            let hocky1 = []
            let hocky2 = []
            if (response.data.hasOwnProperty('arr_1')) {
              hocky1 = response.data.arr_1
            }
            if (response.data.hasOwnProperty('arr_2')) {
              hocky2 = response.data.arr_2
            }
            this.listScore.allObjects = _.concat(hocky1, hocky2)
            break
          case 404:
            break
          default:
            break
        }
      })
    },

    fetchDatabaseModelTestResult () {
      this.load = false
      this.loading = true
      axios.get('test-results/' + this.$route.params.id_test_result).then(response => {
        this.loading = false
        switch (response.code) {
          case 200:
            this.modelScore = response.data
            this.load = true
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xẳy ra',
              message: message,
              type: 'warning'
            })
            this.load = false
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            this.load = false
            break
        }
      })
    },
    updateScoreAttendance (bookingId) {
      this.$prompt('Nhập số điểm chuyên cần muốn chỉnh sửa', 'Tip', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel'
      }).then(({ value }) => {
        this.updateScoreAttendanceAction(bookingId, value)
      }).catch(() => {
      })
    },
    updateScoreAttendanceAction (bookingId, value) {
      let data = {
        score_attendance: value
      }
      axios.post('class-users/update-score-attendance/' + bookingId, data).then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Cập nhật thành công',
              type: 'success'
            })
            this.fetchDatabaseModel()
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    trainingSystem (value) {
      if (value.toLowerCase().includes('liên thông')) {
        return 'Liên Thông'
      }
      if (value.toLowerCase().includes('văn bằng 2')) {
        return 'Văn Bằng 2'
      }
      return 'Chính Quy'
    },
    schoolLevel (value, value2) {
      if (value.toLowerCase().includes('trung cấp')) {
        return 'TRUNG CẤP'
      }
      if (!value.toLowerCase().includes('trung cấp') && !value.toLowerCase().includes('cao đẳng')) {
        if (value2.toLowerCase().includes('trung cấp')) {
          return 'TRUNG CẤP'
        }
        if (value2.toLowerCase().includes('cao đẳng')) {
          return 'CAO ĐẲNG'
        }
      }
      return 'CAO ĐẲNG'
    },
    answer (payload) {
      let answers = payload.model_option
      let options = payload.options.data.filter((item) => {
        if (answers.indexOf(item.id) !== -1) {
          return item
        }
      })
      let data = ''
      let comma = '/'
      options.forEach((item, i) => {
        data += item.text + comma
      })
      return data.slice(0,-1)
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-content {
  padding-top: 15px;
}

table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td,
th {
  padding: 10px 5px;
  text-align: center;
  color: #000728;
}

.delivery-bill th {
  /*background: #767676;*/
  color: #000;
  padding: 10px 0px;
}

td {
  border: 1px solid #000;
}

th {
  border: 0.1px solid #000;
}

.huhu {
  text-align: left;
  padding-left: 10px;
}

.table-common {
  padding-top: 20px;
  padding-bottom: 20px;
  min-height: 500px;
}

.table-common table {
  height: 100%;
  min-height: 500px;
}

.print-2023 {
  margin-top: 20px;
  width: 1000px;
}

.name-school span {
  text-transform: uppercase;
  font-variant: 15px;
  font-weight: bold;
  color: #000;
  margin-bottom: 5px;
}

.name-vn span {
  text-transform: uppercase;
  font-variant: 15px;
  font-weight: bold;
  color: #000;
  margin-bottom: 5px;
}

.name-vn span.text-2 {
  text-transform: inherit;
  font-weight: bold;
}

.line-0999 {
  height: 2px;
  width: 190px;
  border-bottom: 1px solid #000;
  display: inline-block;
}
.line-09991 {
  height: 1px;
  width: 100%;
  display: inline-block;
  position: relative;
}
.line-09991::after {
  content: "";
    position: absolute;
    top: 0;
    left: 50%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    width: 65%;
    border-bottom: 1px solid #000;
}

.main-title-999 {
  font-size: 30px;
  text-transform: uppercase;
  margin-top: 30px;
  margin-bottom: 25px;
  font-weight: bold;
  text-align: center;
}
.main-title-999 .title1 {
  font-size: 20px;
}
.main-title-999 .title2 {
  font-size: 18px;
  margin-bottom: 10px;
}
.text-nowrap-mod {
  width: 205px;
}
.main-info .title {
  min-width: 130px;
  display: inline-block;
  font-size: 15px;
}

.main-info .data {
  font-weight: bold;
  color: #000;
  font-size: 15px;
}

.total-score span {
  font-weight: bold;
  color: #000;
  font-size: 17px;
}

.total-score .text-2 {
  margin-left: 150px;
}

.sign-19231 .addresss {
  margin-bottom: 10px;
  font-style: italic;
  font-weight: 400;
}

.sign-19231 .name {
  text-transform: uppercase;
  color: #000;
  font-weight: bold
}

td,
th {
  padding-top: 2px !important;
  padding-bottom: 2px !important;
}

.table-common {
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}

.main-title-999 {
  font-size: 25px !important;
}

.text-uppercase {
  text-transform: uppercase;
}

.no-border {
  border: none;
  width: fit-content;
}

.no-border tr,
.no-border td {
  border: none;
}
.text-left {
  text-align: left !important;
}
.name-school {
  max-width: fit-content;
  font-size: 18px;
}
.name-wrap {
  position: relative;
}
.name_vn_son {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;
    font-size: 18px;
}
.item-90 span {
  font-weight: bold;
    color: #000;
    font-size: 16px;
}
.item-question {
  width: 47.5%;
  display: inline-grid;
}

item-question:nth-child(even) {
    padding-right: 15px;
}
.item-question:nth-child(odd) {
    padding-left: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/class-pros/showPrintTestResult.vue